export default {"src":"/_next/static/media/neco_bathing.4e793214.svg","height":187,"width":78,"blurWidth":0,"blurHeight":0};